Librarian.Modules.RecentActivity = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-recentactivity-",
        count: 5,
        dayRange: 7,
        trackerTabNames: ["Tracking", "Tracker", "Portal Tracker", "PortalTracker", "Track"]
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        var url = Librarian.path.getMethodUrl("getrar") + "&out=ujson&count=" + this.options.count;
        if (this.options.dayRange > 0) {
            var date = new Date();
            date = Librarian.Utils.extractDateFromString(date.setDate(date.getDate() - this.options.dayRange));

            url += "&sdate=" + encodeURIComponent(date.format("%m/%d/%Y"));
        }

        this.request = new Librarian.Request.JSON({
            url: url,
            onSuccess: this.onDataLoaded.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    },

    onDataLoaded: function(data) {
        if (!data || (data.length == 0))
            return;

        for (var i = 0, length = data.length; i < length; i++) {
            var itemEl = new Element("div", {
                "class": (this.options.classPrefix || '') + "item"
            }).injectInside(this.containerEl);

            var firstName = (data[i].FirstName || '').trim(),
                lastName = (data[i].LastName || '').trim();
            if ((firstName.length + lastName.length) > 0) {
                if (firstName.length > 0) {
                    new Element("span", {
                        "class": (this.options.classPrefix || '') + "firstname",
                        "text": firstName
                    }).injectInside(itemEl);
                }

                if (lastName.length > 0) {
                    new Element("span", {
                        "class": (this.options.classPrefix || '') + "lastname",
                        "text": lastName
                    }).injectInside(itemEl);
                }
            }
            else {
                var email = (data[i].Email || '').trim(),
                    atIndex = email.indexOf('@');

                if (atIndex >= 0)
                    email = email.substring(0, atIndex);

                new Element("span", {
                    "class": (this.options.classPrefix || '') + "lastname",
                    "text": email
                }).injectInside(itemEl);
            }

            var time = Librarian.Utils.extractDateFromString(data[i].ActiveDate).toPrettyFormat(null, false, true);
            new Element("span", {
                "class": (this.options.classPrefix || '') + "time",
                "text": time
            }).injectInside(itemEl);

            var self = this;
            itemEl.set("sessionId", data[i].LastSessionId);
            itemEl.addOnClick(function() {
                // Load the portal tracker and pass the session ID in as a property of the tab itself
                for (var j = self.options.trackerTabNames.length; j--;) {
                    var tab = Library.getTabByName(self.options.trackerTabNames[j]);
                    if (tab) {
                        if(tab.id)
                            var tabId = tab.id.replace(/[^a-z]/gi, '').toLowerCase();
                        //if tab ID isn't set in init file use label as id.
                        else
                            var tabId = self.options.trackerTabNames[j].replace(/[^a-z]/gi, '').toLowerCase();
                        var tabEl = $(tabId);

                        if (tabEl)
                            tabEl.set("sessionId", this.get("sessionId"));

                        Library.loadTabByName(tabId);
                        return;
                    }
                }
            });
        }
    }
});